import { cn } from '../utils/cn';
import { formatFullNumber } from '../utils/formatters';
import { Icon } from './ui/Icon';

interface DarkMatterAmountProps {
    amount: number;
    className?: string;
}

/**
 * Inline icon-plus-amount for the Dark Matter premium currency. It isn't a
 * `ResourceType` (nothing is produced or stored), so it can't ride on
 * `ResourceQuantities`; the icon inherits the surrounding text colour.
 */
export default function DarkMatterAmount({ amount, className }: DarkMatterAmountProps) {
    return (
        <span data-amount="dark-matter" className={cn('inline-flex items-center gap-1 whitespace-nowrap align-middle', className)}>
            <Icon name="dark-matter" size={14} />
            <span>{Number.isFinite(amount) ? formatFullNumber(amount) : '—'}</span>
            <span className="sr-only"> Dark Matter</span>
        </span>
    );
}
